export interface User {
  id?: number;
  first_name?: string;
  last_name?: string;
  gender?: string;
  identification_type?: number;
  identification?: string;
  email?: string;
  default_cc?: string;
  last_push_custom?: string;
  birth_date?: string;
  replacement_criteria_id?: string;
  refered_code?: string;
  country_code?: string;
  country_code_name?: string;
  phone?: string;
  remember_token?: string;
  is_phone_confirmed?: boolean;
  cc_blocked?: string;
  device_id?: number;
  blocked?: boolean;
  exito_id?: number;
  exito_loyalty_type?: string;
  application?: string;
  vip?: boolean;
  paypal_blocked?: boolean;
  name?: string;
  pic?: string;
  rappi_credits?: number;
  rappi_credit?: string;
  rappi_credit_active?: boolean;
  have_orders?: boolean;
  orders_number?: number;
  scope?: string;
  global_phone_number?: string;
  sms_code?: string;
  validate_code?: boolean;
  social_id?: string;
  installments?: number;
  loyalty?: UserLoyalty;
  promo_code?: string | null;
  has_rappicard?: boolean;
}

export interface UserLoyalty {
  name: string;
  type: string;
  active: boolean;
}

export enum UserLoyaltyType {
  Diamond = 'diamond'
}

export interface UserInfo extends User {
  application_user_id?: number;
  auth_token?: string;
  has_rappicard?: boolean;
  has_rappiaccount?: boolean;
  is_prime?: boolean;
  loyalty_level?: string;
  promo_code?: string;
  rappi_segment?: string;
  level_prime?: string;
}
